import React from "react";
import { Sparkles, ArrowUpCircle, Skull } from "lucide-react";
import { VEHICLES } from "../game/config";

export function Countdown({ value }) {
  return (
    <div className="absolute inset-0 z-50 flex items-center justify-center bg-black/40 pointer-events-none" data-testid="countdown">
      <div key={value} className="slam-in font-head font-black text-white text-center">
        <div className="text-8xl sm:text-9xl drop-shadow-[0_0_30px_rgba(255,149,0,0.8)]" style={{ color: value === 0 ? "#FF9500" : "#fff" }}>
          {value === 0 ? "GO!" : value}
        </div>
      </div>
    </div>
  );
}

export function EvolutionOverlay({ data }) {
  return (
    <div className="absolute inset-0 z-50 flex items-center justify-center pointer-events-none" data-testid="evolution-overlay">
      <div className="slam-in text-center px-6">
        <div className="flex items-center justify-center gap-2 text-cyan-300 font-bold uppercase tracking-[0.3em] text-sm mb-2">
          <Sparkles size={18} /> Evolution <Sparkles size={18} />
        </div>
        <div className="font-head font-black text-5xl sm:text-7xl text-transparent bg-clip-text bg-gradient-to-r from-amber-300 via-yellow-200 to-orange-500 drop-shadow-[0_0_30px_rgba(255,204,0,0.9)]">
          EVOLUTION!
        </div>
        <div className="mt-3 text-2xl sm:text-4xl font-black text-white">{data.name}</div>
        <div className="mt-1 text-amber-400 font-bold">Bigger. Stronger. Unstoppable.</div>
      </div>
    </div>
  );
}

export function LevelToast({ level }) {
  return (
    <div className="absolute left-1/2 -translate-x-1/2 top-1/3 z-50 pointer-events-none" data-testid="levelup-toast">
      <div className="pop-in card px-6 py-3 border-amber-500/50 glow-pulse text-center">
        <div className="flex items-center gap-2 text-amber-400 font-black text-xl sm:text-2xl font-head">
          <ArrowUpCircle size={24} /> LEVEL {level}!
        </div>
      </div>
    </div>
  );
}

export function KillFeed({ kills }) {
  return (
    <div className="absolute left-1/2 -translate-x-1/2 bottom-24 sm:bottom-28 z-40 flex flex-col items-center gap-1 pointer-events-none" data-testid="kill-feed">
      {kills.map((k) => (
        <div key={k.id} className="pop-in card px-3 py-1 border-red-500/40 flex items-center gap-2 text-sm">
          <Skull size={14} className="text-red-400" />
          <span className="text-white font-bold">Smashed <span className="text-red-400">{k.name}</span></span>
        </div>
      ))}
    </div>
  );
}

export function RespawnOverlay({ by, hud }) {
  return (
    <div className="absolute inset-0 z-50 flex items-center justify-center bg-black/60 pointer-events-none" data-testid="respawn-overlay">
      <div className="text-center pop-in">
        <div className="text-red-400 font-head font-black text-4xl sm:text-6xl">SMASHED!</div>
        <div className="text-slate-300 mt-2">Destroyed by <span className="text-white font-bold">{by}</span></div>
        <div className="mt-4 text-amber-400 font-black text-2xl font-head">Respawning in {hud?.respawnIn > 0 ? hud.respawnIn : 1}...</div>
      </div>
    </div>
  );
}
